var React = require('react');

function CounterInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"className":"counterbg","cx":"50","cy":"50","r":"45","key":0}),React.createElement("circle",{"className":"counteranimate","cx":"50","cy":"50","r":"45","key":1})]);
}

CounterInline.defaultProps = {"className":"counter","viewBox":"0 0 100 100"};

module.exports = CounterInline;

CounterInline.default = CounterInline;
